<template>
  <div class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">
    <div class="rounded-t bg-white mb-0 px-6 py-6">
      <div class="text-center flex justify-between">
        <h6 class="text-blueGray-700 text-xl font-bold">My account</h6>
        <button
          class="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
          @click="updateProfile" type="button">
          Submit
        </button>
      </div>
    </div>
    <div class="w-full  px-4 lg:px-10 py-10 pt-0 mt-5" v-if="alertType != ''">
      <div class="text-white px-4 py-2 border-0 rounded relative mb-4"
        v-bind:class="{ 'bg-emerald-500': alertType == 'Success', 'bg-red-500': alertType == 'Failed' }">
        <span class="text-m inline-block mr-5 align-middle">
          <i class="fas fa-bell"></i>
        </span>
        <span class="inline-block align-middle mr-8">
          <b class="capitalize">{{ alertType }}!</b> {{ alertMessage }}
        </span>
        <button
          class="absolute bg-transparent text-2xl font-semibold leading-none right-0 top-0 mt-2 mr-6 outline-none focus:outline-none">
          <span>×</span>
        </button>
      </div>
    </div>
    <div class="flex-auto px-4 lg:px-10 py-10 pt-0">
      <form>
        <h6 class="text-blueGray-400 text-sm mt-3 mb-6 font-bold uppercase">
          User Information
        </h6>
        <div class="flex flex-wrap">
          <div class="w-full lg:w-6/12 px-4">
            <div class="relative w-full mb-3">
              <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                Username
              </label>
              <input type="text"
                class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                v-model="client.username" />
            </div>
          </div>
          <div class="w-full lg:w-6/12 px-4">
            <div class="relative w-full mb-3">
              <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                Password
              </label>
              <input type="password"
                class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" />
            </div>
          </div>
          <div class="w-full lg:w-6/12 px-4">
            <div class="relative w-full mb-3">
              <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                Fullname
              </label>
              <input type="text"
                class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                v-model="client.fullname" />
            </div>
          </div>
          <div class="w-full lg:w-6/12 px-4">
            <div class="relative w-full mb-3">
              <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                Role
              </label>
              <select v-model="client.role_id"
                class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150">
                <option v-for="(item, key) in roles" :value="item.id" :key="key">
                  {{ item.role }}
                </option>
              </select>
            </div>
          </div>
        </div>

      </form>
    </div>
  </div>
</template>


<script>
import RoleDataService from "@/services/RoleDataService";
import UserDataService from "@/services/UserDataService";
// import { useUserStore } from '@/stores/user';
// import { storeToRefs } from 'pinia';
import { useToast } from "vue-toastification";
export default {
  setup() {
    const toast = useToast();

    //   const user = useUserStore();
    //   // eslint-disable-next-line no-unused-vars
    //   const { Username, Fullname } = storeToRefs(user);
    //   console.log(user.user.Role)
    //   return {
    //     // you can return the whole store instance to use it in the template
    //     user,
    //   }
    return { toast }

  },
  data() {
    return {
      alertType: '',
      alertMessage: '',
      client: {},
      roles: []
    };
  },
  components: {

  },
  mounted() {
    this.client = {}
    this.getProfile()
    this.getRoles()
  },
  methods: {
    getRoles() {
      RoleDataService.getAll(100, 1)
        .then(response => {
          this.roles = response.data["data"]["roles"];

        })
        .catch(e => {
          this.toast.error(e.response.data['code_message']);
        });
    },
    getProfile() {
      UserDataService.get()
        .then(response => {
          var user = response.data['data']['registration_data']
          this.client = {
            username: user.username,
            fullname: user.fullname,
            role_id: user.role_id,
          }
        })
        .catch(e => {
          var pathname = document.location.pathname
          var unauthorized = true

          unauthorized = (e.response != null && (e.response.status == 401 || e.response.data['code'] == 401))

          if ((pathname != 'auth/login' && pathname != 'auth/register') && unauthorized) {
            localStorage.removeItem('user')
            localStorage['flash'] = 'Please re-login to continue'
            document.location = ''
          } else {
            this.alertType = 'Failed'
            this.alertMessage = e.response.data.code_message
            this.countDownTimer(3)
            console.log(e);
          }
        });
    },
    updateProfile() {
      console.log(this.client)
      UserDataService.update(this.client)
        .then(() => {
          this.alertType = 'Success'
          this.alertMessage = 'Profile successfuly updated'
          setTimeout(() => {
            this.alertType = ''
            this.alertMessage = ''
          }, 3000)
        })
        .catch(e => {
          this.alertType = 'Failed'
          this.alertMessage = e.response.data.code_message
        });
    }
  }
}
</script>